/**
 * card.js
 * show and hide backside information
 *
 */

import { Card as OrbitBase } from '../../original/js/components/card';

export class Card extends OrbitBase{
  /**
   * Check if slick slider is active and parent DIV exists
   * @param element - element containing the card
   */
  slickSliderActive(element) {
    // Added this check if parentElement exists - fix for NextJS apps.
    if (!element || !element.parentElement) return;
    return (
      element.hasAttribute('data-rs-carousel-card') &&
      element.parentElement.tagName === 'DIV'
    );
  }
}

